import React from "react"
import { FormattedMessage } from "react-intl"
import Tabs from "../../common/layout/tabs.component"
import { AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"
import SpanWrapper from "../../common/rich-text/feature-protection-wrappers/spanWrapper.component"

const ContactTabs = () => {

    const tabs = [
        {
            name: <FormattedMessage
                id="contact.listing.contact_tabs"
                defaultMessage="Contacts"
            />,
            link: "/contacts/listing",
        }, {
            name: <FormattedMessage
                id="companies.listing.companies_tabs"
                defaultMessage="Companies"
            />,
            link: "/companies/listing",
        },
    ]

    tabs.push({
        name: <SpanWrapper
            tooltipPlacement="bottom"
            redirectToAccount={true}
            accountFeatureKey={AccountFeatures.FeatureInventory}>
            <FormattedMessage
                id="suppliers.listing.suppliers_tabs"
                defaultMessage="Suppliers"
            />
        </SpanWrapper>,
        link: "/suppliers/listing",
    })


    return <>
        <Tabs value={tabs}/>
    </>
}

export default ContactTabs


// WEBPACK FOOTER //
// ./src/customer/components/contactTabsComponent.tsx